// extracted by mini-css-extract-plugin
export default {"container-fluid":"Testimonial_container-fluid__r1eEU","card":"Testimonial_card__3cBCG"};